import styled from '@emotion/styled';
import { useFormContext } from 'old-rhf';

import {
  getFieldError,
  InputGroupBase,
  InputGroupBaseItems,
  InputGroupBaseProps,
  CardInputBase,
  CheckboxBase,
  RadioBase,
  FCC
} from '@zazume/zzm-base';

interface InputGroupProps extends Omit<InputGroupBaseProps, 'error'> {
  centered?: boolean;
}

const CenteredWrapper = styled.div`
  width: 100%;
  & > div > div {
    justify-content: center;
  }
`;

/**
 * @deprecated This component will be removed after the RHF migration is complete. Use the ZZMForm equivalent from @zazume/zzm-base instead.
 */
export const InputGroup: FCC<InputGroupProps> & InputGroupBaseItems = ({ centered = false, ...props }) => {
  const {
    register,
    formState: { errors }
  } = useFormContext();

  const error = getFieldError(props.name, errors);

  const inputGroup = <InputGroupBase {...props} ref={register} error={error} />;

  return centered ? <CenteredWrapper>{inputGroup}</CenteredWrapper> : inputGroup;
};

InputGroup.RadioInput = RadioBase;
InputGroup.CheckboxInput = CheckboxBase;
InputGroup.CardInput = CardInputBase;
